exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* this file will be extracted to main dist folder and is imported in index.html */\n/* This file is for setting global styles  */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/styles/styles.scss
// module id = 202
// module chunks = 0